/*
 * This composable is used to get the embed url of a video from a given url supporting youtube and vimeo.
 * If onlyId is set to true, it will return only the id of the video.
 * If the url is not a youtube or vimeo url, it will return the same url e.g for mp4, webm, etc.
 */

export const useGetVideoEmbedUrl = (url, onlyId = false) => {
  if (!url) {
    return null
  }

  const youtubeRegex = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
  const vimeoRegex = /(?:vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/[^\/]+\/videos\/|video\/|)|vimeo\.com\/)([0-9]+)/

  const youtubeMatch = url.match(youtubeRegex)
  if (youtubeMatch && youtubeMatch[1]) {
    if (onlyId) {
      return youtubeMatch[1]
    }
    return `https://www.youtube-nocookie.com/embed/${youtubeMatch[1]}`
  }

  const vimeoMatch = url.match(vimeoRegex)
  if (vimeoMatch && vimeoMatch[1]) {
    if (onlyId) {
      return vimeoMatch[1]
    }
    return `https://player.vimeo.com/video/${vimeoMatch[1]}`
  }

  return null
}
